/**
 * @generated SignedSource<<1cd69108b006cae7909d1aebacca23f9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type checkoutUIActions_buyer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"checkoutTransactionReducer_buyer">;
  readonly " $fragmentType": "checkoutUIActions_buyer";
};
export type checkoutUIActions_buyer$key = {
  readonly " $data"?: checkoutUIActions_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutUIActions_buyer">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "checkoutUIActions_buyer"
};

(node as any).hash = "3d52ef0e5cbf864211b79dd3df6c95c3";

export default node;
